import { useEffect, useState } from 'react';
export function useReducedMotion() {
 const [reduced,setReduced]=useState(() => typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches);
 useEffect(()=>{const query=window.matchMedia?.('(prefers-reduced-motion: reduce)'); if(!query) return; const update=()=>setReduced(query.matches); query.addEventListener?.('change',update); return ()=>query.removeEventListener?.('change',update);},[]);
 return reduced;
}
